/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flex-container{-webkit-appearance:None;-moz-appearance:None;appearance:None;display:flex;justify-content:space-between;height:100%;width:100%;background-color:inherit;position:sticky;top:0;margin-bottom:5px;border-bottom:1px solid rgba(0,0,0,.42);z-index:1000}.flex-container .mat-option{width:100%}\n/*# sourceMappingURL=meg-searchable-dropdown.css.map*/"];
export { styles as styles };
